export const subjectType = Object.freeze({
  ENTERPRISE: 1, // 企业
  PERSONAL: 2, // 个人
})

export const OrderSegmentTypeEnum = Object.freeze({
  live: 200, // 直播电商 = 200,//商品类型通过ProductType判断   200是H5，小程序是290
  liveapp: 290, // 直播小程序电商 ,
  Home: 1207, // 家居定金
  HomeFlash: 1208, // 家居秒杀
  auction: 292, // 竞拍商品
  discount: 1288, //  满减满折订单
  deposit: 1299, // 定金支付 ,
  Appointment: 1211, // 预约金订单
  group: 1212, // 商品拼团订单
  Flash: 240, //  直播间秒杀
  BlindBox: 1224, // 盲盒订单
  Flashbuy: 1227, // 闪购商品订单
})

// 订单状态
export const orderStatusEnum = {
  unPay: 0, // 未付款
  Paying: -4, // 待支付
  beDelivery: 1, // 待发货
  beReceive: 5, // 待收货
  CANCEL: -1, // 取消交易
  refunded: 16, // 已退款
  COMPLETED: 10, // 已完成 - 确认收货
}

// 退款状态
export const refundStatusEnum = {
  CLOSED: -18, // 已关闭
}

// 目前退款申请进度状态
export const ACTION_STATE = {
  OnMaster: 0, // 等待商家处理
  OnBuyer: 6, // 商家拒绝，等待买家处理
  Revoke: 1, // 撤销申请 // [Description("您撤销了本次退款申请")]
  TimeOut: 2, // 超时未处理 [Description("买家超时未处理自动关闭")]
  Refuse: 3, // 拒绝申请 // [Description("卖家拒绝了退款申请")]
  Closed: 4, // 正常途径关闭
  Agree: 5, // 已同意退款
  Process: 7, // 退款中
  Success: 8, // 退款成功
  Rebate: 9, // 部分退款
  Fail: -1, // 退款失败
  Other: -2, // 默认状态
  ToBeReceived: 10, // 待商家收货
  OnMasterRefound: 11, // 待商家退款
}

// 商品退款类型
export const REFUND_TYPE = {
  INITIATIVE_REFUND: '主动退款',
  APPLY_REFUND: '申请退款', // 申请退款
  OFFLINE_RETURN: '线下退货',
}
export const STATE_ENUM = {
  Processing: 0, // 进行中
  Refunded: 1, // 已退款
  Closed: 2, // 已关闭
}
export const reason_ENUM = [
  { name: '未按约定时间发货', value: 1 },
  { name: '拍错/拍多/不喜欢', value: 2 },
  { name: '与商家协商一致退款', value: 3 },
  { name: '商品与商家描述不符', value: 5 },
  { name: '少件/漏发', value: 6 },
  { name: '包装/商品破损/污迹/裂痕/变形', value: 7 },
  { name: '卖家发错货', value: 8 },
  { name: '其他', value: 4 },
]
export const REFUNDWAY_ENUM = Object.freeze({
  0: '仅退款',
  1: '退货退款',
  2: '线下退货',
  3: '计重退款',
})

export const ORDER_API_CODE = {
  /** @name 未付款单 */
  unPay: 1599,
  /** @name 拆单 */
  splitOrder: -10,
}
/**
 * @remark orderType 并非是订单类型，是对应 deliveryType 的另一种形式
 */
export const ORDER_D_TYPE = {
  /** @remark 未知，购物车下单url未携带orderType参数，并且subtotal请求返回前 */
  unknow: -10,
  /** @name 配送 1 */
  deliver: 1,
  /** @name 常规核销（自提） 2 */
  generalVerify: 2,
  /** @name 门店核销（自提） 3 */
  storeVerify: 3,
  /** @name 导购核销 4 */
  guidVerify: 4,
  /** @name 配送+自提 5 */
  slfCollectOrDel: 5,
  /** @name 门店自提（无需核销）6 */
  selfCollect: 6,
}
export const DELIVER_TYPE = {
  /** @name 商家配送 1 */
  deliver: 1,
  /** @name 门店自提 2 */
  selfCollect: 2,
  /** @name 常规核销 10 */
  generalVerify: 10,
  /** @name 门店核销 11 */
  storeVerify: 11,
  /** @name 导购版门店自提 12 */
  guidVerify: 12,
}
export const DELEVER_SWITCH = {
  /** @name 配送Tab */
  address: 1,
  /** @name 自提Tab */
  store: 2,
}
export const SET_ORDER_ACTION = {
  integralChange: 1,
  initOrder: 2,
  none: 4,
}
export const ORDER_DISCOUNT_TYPE = {
  integral: 11,
  voucher: 12,
}

export const PAY_MODE = {
  0: '微信支付',
  1: '支付宝支付',
}
